/* global IntersectionObserver */
import { register } from '../../../Javascript/Utils'

const ScrollImage = el => {
  const hotspots = el.querySelectorAll('.medacMoleculeScrollimage-hotspot-wrapper')

  const observerOptions = {
    root: null,
    threshold: 0.9
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const element = entry.target

      if (entry.isIntersecting) {
        // Prüfen: Kommt das Element von unten?
        // (Die Oberkante ist positiv, also weiter unten im Viewport)
        if (entry.boundingClientRect.top > 10) {
          // FALL 1: Normales Runter-Scrollen
          // Transition erlauben (falls sie vorher deaktiviert war)
          element.classList.remove('no-transition')
          element.classList.add('is-visible')
        } else {
          // FALL 2: Hoch-Scrollen (Element kommt von oben rein)
          // Transition deaktivieren -> Sofort anzeigen
          element.classList.add('no-transition')
          element.classList.add('is-visible')
        }
      } else {
        // Element verlässt den Bildschirm -> Reset
        element.classList.remove('is-visible')
        // 'no-transition' entfernen wir hier auch, damit beim nächsten
        // Mal wieder sauber neu entschieden werden kann.
        element.classList.remove('no-transition')
      }
    })
  }, observerOptions)

  hotspots.forEach(spot => {
    observer.observe(spot)
  })
}

register('ScrollImage', ScrollImage)
